export default __webpack_public_path__ + "static/icon-callout-hp-dosing-f72273b302271116860bb293e4bd7ea9.png";